import { useNavigate, useLocation } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import Layoutviewpage from "../../../components/common/View/View-Layout";


const BranchView = () => {
  const feedback = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const viewBranch = location?.state?.data;

  const fields = [
    { name: "branch_name", label: "Branch Name", type: "text", placeholder: "", hidden: false , required:true},
  ];
  useEffect(() => {

    if (viewBranch) {
      setInitialValues({
        branch_name: viewBranch.branch_name || "",
      });
    }

  }, [viewBranch]);
  const handleCancel = () => {
    navigate("/gym-branch-list" ,{ state: { pageName: "Branch" } });
  };

  return (
    <div className="pb-4 pt-3 ">
      <Layoutviewpage
        title="View Branch"
        onCancel={handleCancel}
        loading={loading}
        fields={fields}
        initialValues={initialValues}
      />
    </div>
  );
};
export default BranchView;
